import { render, staticRenderFns } from "./bank-table.vue?vue&type=template&id=33c26b39&"
import script from "./bank-table.vue?vue&type=script&lang=js&"
export * from "./bank-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports